module.exports = __webpack_public_path__ + "8b40fc1398bd7502586d7410ba6b8581.svg";